import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadModelHandForDropdownDto } from '../../api/models';

export type TABLE_TYPE = Table<HeadModelHandForDropdownDto>;

export const TABLE = 'headModelHand';
const SCHEMA = 'headModelHandId';

class HeadModelHandForDropdownDtoDatabase implements DataRepository<HeadModelHandForDropdownDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadModelHandForDropdownDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadModelHandForDropdownDto, key: Key): Promise<HeadModelHandForDropdownDto> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadModelHandForDropdownDto[]): Promise<HeadModelHandForDropdownDto[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadModelHandForDropdownDto[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadModelHandForDropdownDtoDB = new HeadModelHandForDropdownDtoDatabase(db);
